import React from 'react';
import styled from 'styled-components';
import Presets from './Sale/components/Presets/Presets';
import Receipt from './Sale/components/Receipt/Receipt';
import { useParams } from 'react-router';
import { SnackbarProvider } from 'notistack';


const SalesWrapper = styled.div`
  display: grid;
  height: 100%;
  min-width: 600px;
  grid-template-columns: auto 400px;
  grid-template-rows: auto;
`;

const Sale = () => {
  let { id: transactionId } = useParams();
  if (!transactionId) {
    transactionId = 'new';
  }

  return (
    <SalesWrapper>
      <SnackbarProvider anchorOrigin={{ horizontal: 'center', vertical: 'top' }}>
        <Presets transactionId={transactionId} />
        <Receipt transactionId={transactionId} />
      </SnackbarProvider>
    </SalesWrapper>
  );
};

export default Sale;
